import React, { useEffect, useState } from 'react'
import '../Screen/home.css'
import intro from '../image/01.png'
import LiveFont from '../Component/livefont'
import Header from '../Component/header'
import AboutUS from '../Component/aboutUS'
import Skills from '../Component/skills'
import CardsTimeLine from '../Component/cards'
import ContactUS from '../Component/contactUS'
import Project from '../Component/project'

export default function Home() {
  return (
    <div>
      <Header/>
      <div className='intro'> 
      <div className="inleft">
        <div className='fset'>
        <p data-aos="fade-down">Hi, my name is</p>
        <h1 data-aos="fade-left">Waleed Ahmed</h1>
        <h2 data-aos="fade-right">I'm a Passionate</h2>
        </div>
        <h2 data-aos="fade-left"><LiveFont/></h2>
      </div>
      <div className='inright' data-aos="flip-left">
        <div>
        <img src={intro}/></div>
        </div>
      </div>
      <div>
        <AboutUS/>
      </div>
      <Skills/>
      <br/>
      <CardsTimeLine/>
      <br/>
      <Project/>
      <br/>
      <ContactUS/>
    </div>
  )
}
